<div>
  <filter-search-box (textChanged)="applyFilter($event)" />
</div>

<table
  mat-table
  cdkDropList
  (cdkDropListDropped)="onDrop($event)"
  [cdkDropListDisabled]="dragDisabled"
  [dataSource]="tableSource">

  <!--- Note that these columns can be defined in any order.
  The actual rendered columns are set as a property on the row definition" -->

  <ng-container matColumnDef="position" >
    <th mat-header-cell *matHeaderCellDef>Position</th>
    <td mat-cell *matCellDef="let element">
      <div>
        <mat-icon [ngClass]="{'move-cursor': !PhonebookTableService.isNewEntry(element.value)}"
        (mousedown)="dragDisabled = PhonebookTableService.isNewEntry(element.value)">reorder</mat-icon>
        <span>{{ element.value.priorityOrder }}</span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Kontakt</th>
    <td mat-cell *matCellDef="let element">
      @if (!editingRows.includes(element.value.id)) {
        <span>{{ element.value.name }}</span>
      }

      @if (editingRows.includes(element.value.id)) {
        <mat-form-field
          appearance="outline"
          >
          <mat-label>Kontakt</mat-label>
          <input matInput [formControl]="element.controls.name"/>
          @if (element.controls.name.hasError('required')) {
            <mat-error>Måste anges</mat-error>
          }
        </mat-form-field>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>Beskrivning</th>
    <td mat-cell *matCellDef="let element">
      @if (!editingRows.includes(element.value.id)) {
        <span>{{ element.value.description }}</span>
      }
      @if (editingRows.includes(element.value.id)) {
        <mat-form-field appearance="outline">
          <mat-label>Beskrivning</mat-label>
          <input matInput [formControl]="element.controls.description"/>
        </mat-form-field>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="category">
    <th mat-header-cell *matHeaderCellDef>Kategori</th>
    <td mat-cell *matCellDef="let element">
      @if (!editingRows.includes(element.value.id)) {
        <span>{{ getCategoryName(element.value.categoryId) }}</span>
      }
      @if (editingRows.includes(element.value.id)) {
        <mat-form-field appearance="outline">
          <mat-label>Kategori</mat-label>
          <mat-select [(value)]="element.value.categoryId" [formControl]="element.controls.categoryId">
            @for (option of categoryOptions(); track option) {
              <mat-option [value]="option.value">{{ option.text }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="phoneNumber">
    <th mat-header-cell *matHeaderCellDef>Telefon</th>
    <td mat-cell *matCellDef="let element">
      <div>
        @if (!editingRows.includes(element.value.id)) {
          <span>{{ element.value.phoneNumber }}</span>
        }
        @if (editingRows.includes(element.value.id)) {
          <mat-form-field appearance="outline">
            <mat-label>Telefon</mat-label>
            <input matInput [formControl]="element.controls.phoneNumber"/>
            @if (element.controls.phoneNumber.hasError('required')) {
              <mat-error>Måste anges</mat-error>
            }
            @if (element.controls.phoneNumber.hasError('pattern')) {
              <mat-error>Får enbart innehålla siffror, mellanslag och bindestreck. Max 20 tecken</mat-error>
            }
          </mat-form-field>
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="phoneNumberNote">
    <th mat-header-cell *matHeaderCellDef>Notis</th>
    <td mat-cell *matCellDef="let element">
      @if (!editingRows.includes(element.value.id)) {
        <span>{{ element.value.phoneNumberNote }}</span>
      }
      @if (editingRows.includes(element.value.id)) {
        <mat-form-field appearance="outline">
          <mat-label>Notis</mat-label>
          <input matInput [formControl]="element.controls.phoneNumberNote"/>
        </mat-form-field>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Åtgärder</th>
    <td mat-cell *matCellDef="let element">
      <div>
        @if (editingRows.includes(element.value.id)) {
          <button mat-icon-button color="primary" matTooltip="Spara"
            (click)="save(element, 'Regular')">
            <mat-icon>save</mat-icon>
          </button>
        }

        @if (editingRows.includes(element.value.id)) {
          <button mat-icon-button matTooltip="Radera"
            (click)="delete(element.value)">
            <mat-icon>delete_forever</mat-icon>
          </button>
        }

        <div [matTooltip]="getVisibilityTooltipText(element.value.visible, element.value.id)">
          <button mat-icon-button [formGroup]="element.controls.visible" (click)="setVisibility(element)"
            [disabled]="!editingRows.includes(element.value.id)">
            @if (element.value.visible && editingRows.includes(element.value.id)) {
              <mat-icon>visibility</mat-icon>
            }
            @if (!element.value.visible) {
              <mat-icon>visibility_off</mat-icon>
            }
          </button>
        </div>

        @if (!editingRows.includes(element.value.id)) {
          <button mat-icon-button matTooltip="Redigera"
            (click)="edit(element.value.id)">
            <mat-icon>edit</mat-icon>
          </button>
        }

        @if (editingRows.includes(element.value.id)) {
          <button mat-icon-button matTooltip="Återställ"
            (click)="reset(element.value.id, element)">
            <mat-icon>undo</mat-icon>
          </button>
        }
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row
    cdkDrag
    [cdkDragData]="row"
    [ngClass]="{ 'has-changes': row.dirty }"
    *matRowDef="let row; columns: displayedColumns"
  ></tr>
</table>

<mat-divider />

<div class="footer">
  <button mat-flat-button color="primary" (click)="createNewContactRow()" class="footer__button">Skapa ny kontakt<mat-icon>person_add</mat-icon></button>
</div>
